export default __webpack_public_path__ + "static/media/Project-4-SingleProject-MainImg.b2c2577f.png";